<template>
    <div
        class="roadmap-create"
        v-if="loaded">
        <design-2021-roadmap-edit-title-component :roadmap-in="roadmap"> </design-2021-roadmap-edit-title-component>

        <div class="steps-edit-content">
            <div
                class="row"
                v-if="roadmap">
                <div class="col-12 col-md-4 col-xl-3 steps-edit-sidebar-menu">
                    <div class="apprentice-simple-card">
                        <div class="generic-settings">
                            <div class="component-title">
                                <h5 class="title">Algemeen</h5>
                            </div>

                            <div class="linked">
                                <b-form-group
                                    class="liked-setting-group"
                                    label-cols="12"
                                    label-cols-lg="10"
                                    content-cols="12"
                                    content-cols-lg="2"
                                    label="Stappenplan koppelen aan project"
                                    label-for="linked-setting-toggle">
                                    <b-form-checkbox
                                        class="linked-toggle-setting"
                                        id="linked-setting-toggle"
                                        v-model="linked"
                                        switch
                                        @change="attachRoadmap">
                                    </b-form-checkbox>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <design-2021-roadmap-edit-steps-nav-component
                        :roadmap-in="roadmap"
                        :steps="roadmap.steps"
                        @order-changed="orderChanged">
                    </design-2021-roadmap-edit-steps-nav-component>
                </div>
                <div class="col-12 col-md-8 col-xl-9">
                    <design-2021-roadmap-edit-steps-component :roadmap-in="roadmap">
                    </design-2021-roadmap-edit-steps-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { ords } from '../../app';

export default {
    name: 'design-2021-roadmap-create-component',
    props: ['roadmapIn', 'groupIn'],
    components: {
        draggable,
    },
    data() {
        return {
            roadmap: {},
            loaded: false,
            linked: false,
        };
    },

    methods: {
        orderChanged() {
            let array = [];
            let counter = 0;

            ords.hold();

            for (let step of this.roadmap.steps) {
                counter++;

                step.update({ order: counter });

                step.order = counter;
                array.push({
                    id: step.id,
                    order: counter,
                });
            }

            ords.continue();

            const data = {
                roadmap_id: this.roadmap.id,
                blocks: array,
            };

            this.axios.post(this.routes.roadmapStepOrder(), data).then(
                (response) => {}, // no action required
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        attachRoadmap() {
            const data = {
                id: this.roadmapIn.id,
            };

            this.alert.saving();
            this.axios.post(this.routes.roadmapProjectToggle(this.groupIn.id), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },

    mounted() {
        if (!this.loaded) {
            ords.use('roadmap').add(this.roadmapIn);

            ords.use('roadmap')
                .with('steps', (stepsCallback) => {
                    stepsCallback.with('deadline');
                    stepsCallback.orderBy('order');
                })
                .with('group')
                .find(this.roadmapIn.id)
                .subscribe((roadmap) => {
                    this.roadmap = roadmap;
                });

            this.linked = this.roadmapIn.group !== null;

            this.loaded = true;
        }
    },
};
</script>

<style scoped lang="scss">
.generic-settings {
    > div:not(:last-child) {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.component-title {
    color: $primary;
    font-weight: $font-weight-bolder;
    border-bottom: 1px solid $border-color;
    padding-bottom: map-get($grid-gutter-spacing, 'eight');
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.steps-drag-handle {
    color: lightgray;
    margin-right: 15px;
}
.steps-drag-handle:hover {
    color: black;
}

.list-group-item {
    border: none;
    font-size: 0.875rem;
}

.list-group-item:hover,
.list-group-item.active {
    background-color: #e8eff4bf;
    color: #212529;
}

.edit-roadmap .header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 21px;
    flex-direction: column;
}

.edit-roadmap .header > .actions {
    align-self: flex-end;
}

.steps-edit-nav {
    margin-bottom: 60px;
}

@media (min-width: 768px) {
    .steps-edit-nav {
        margin-bottom: 0px;
    }

    .edit-roadmap .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 21px;
        flex-direction: row;
    }

    .edit-roadmap .header > .actions {
        align-self: baseline;
    }
}

.roadmap-header {
    .title-label {
        font-size: 1.3125rem;
    }

    input {
        border: 1px solid $border-color;
    }
}

//.roadmap-create-nav-steps{
//      .component-title {
//          padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'fifteen');
//          margin-bottom: map-get($grid-gutter-spacing, 'ten');
//          background-color: $primary;
//          color: $white;
//          border-radius: 4px;
//      }
//
//    .roadmap-steps-nav{
//        .roadmap-step-nav-item {
//            padding-bottom: map-get($grid-gutter-spacing, 'ten');
//
//            .roadmap-step-nav-link {
//                display: flex;
//                flex-direction: row;
//                align-items: baseline;
//                color: $text-color;
//                padding: 12px 20px;
//
//                .drag-handle {
//                    margin-right: map-get($grid-gutter-spacing, 'fifteen');
//                }
//
//                &:hover {
//                    &,
//                    .title,
//                    .drag-handle {
//                        color: $primary;
//                        cursor: pointer;
//                    }
//
//                    .drag-handle {
//                        color: $primary;
//                    }
//                }
//            }
//
//            &:not(:last-child){
//                border-bottom: 3px dotted $border-color;
//                margin-bottom: map-get($grid-gutter-spacing, 'ten');
//            }
//        }
//    }
//}
</style>
